import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { getAuthHeaders } from 'src/app/core/http/user-auth';

@Injectable({ providedIn: 'root' })
export class ImageCacheService {
  private cache = new Map<string, Blob>();
  private pending = new Map<string, Observable<Blob>>();

  constructor(private http: HttpClient) {}

  getImageUrl(url: string): Observable<Blob> {
    if (this.cache.has(url)) {
      return of(this.cache.get(url));
    }

    if (this.pending.has(url)) {
      return this.pending.get(url);
    }

    const observable = this.http
      .get(url, {
        headers: {
          ...getAuthHeaders(),
        },
        responseType: 'blob',
      })
      .pipe(
        tap((blob: Blob) => {
          this.cache.set(url, blob);
          this.pending.delete(url);
        }),
      );

    this.pending.set(url, observable);
    return observable;
  }
}
